module.exports = __webpack_public_path__ + "static/media/gallery-11.e54361e7.jpg";